window.jQuery = window.$ = jQuery;
var engoApps = {
  init: function() {
    this.init_MobileMenu();
  },
  init_MobileMenu: function(){
        $(document).on('click','#hamburger_icon',function(e){
          e.preventDefault();
          $(this).toggleClass('active');
          $('body').toggleClass('opened-nav-animate');
          setTimeout(function(){
            $('body').toggleClass('opened-nav');
          }, 100);
        });

        $('ul.navigation-mobile ul.sub-menu-dropdown, ul.navigation-mobile .engoj-megamenu-wrapper').each(function(){
            $(this).parent().children('a').prepend( '<span class="open-submenu"></span>' );
        });

        $(document).on('click','.open-submenu', function(e){
            e.stopPropagation();
            e.preventDefault();          
            $( this ).closest('li').toggleClass('active-menu-item');
            $( this ).closest('li').children( '.sub-menu-dropdown, .engoj-megamenu-wrapper' ).slideToggle();
        });

        $(window).resize(function(){
            var $navHeight = $(window).height() - $('.navbar-container').height();
            $('.main-nav-mobile').css({'max-height': $navHeight});
        });
    }
}
engoApps.init();